import { useState } from 'react';
import useFetch from 'lib/hooks/useFetch';

import { Icon } from '@frontendmentorio/design-system-v2';

import List from './List';

export default function Directory({
  directory,
  selectedFile,
  setIsEditorVisible,
  setSelectedFile,
  solution,
}) {
  const [isOpen, setIsOpen] = useState();

  const {
    data: { data: contents = [] },
    isLoading,
  } = useFetch(
    isOpen
      ? `/api/v3/services/repo?url=${solution.repoURL}&entity=${directory.path}`
      : null
  );

  return (
    <>
      <button
        className="flex items-center gap-3 px-3 py-[0.2rem] rounded w-full whitespace-nowrap hover:bg-[hsl(0,0%,91%)] disabled:cursor-auto disabled:text-neutral-500 disabled:hover:bg-transparent"
        disabled={!directory.isAllowed}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="flex justify-center text-sm w-[1rem]">
          <Icon
            name={contents?.length > 0 && isOpen ? 'folder-open' : 'folder'}
          />
        </span>

        <span className="text-sm">{directory.name}</span>

        {isLoading && isOpen && (
          <Icon className="animate-spin ml-auto" name="spinner-third" />
        )}
      </button>

      {contents?.length > 0 && (
        <List
          className="border-l border-neutral-200 pl-2 ml-4"
          items={contents}
          selectedFile={selectedFile}
          setIsEditorVisible={setIsEditorVisible}
          setSelectedFile={setSelectedFile}
          solution={solution}
        />
      )}
    </>
  );
}
